import { Textarea, TextareaProps } from '@mantine/core'
import { useState } from 'react'

const DEFAULT_ROWS = 6

type MultilineTextListInputProps = Omit<TextareaProps, 'value' | 'onChange'> & {
  value?: string[]
  onChange: (value: string[]) => void
}

// This component lets you type in a list of items, each on a new line.
// It takes the list as an array of strings and updates it when you make changes.
export const MultilineTextListInput = ({
  value = [],
  onChange,
  ...props
}: MultilineTextListInputProps) => {
  const [text, setText] = useState(value.join('\n'))

  const handleChange = (value: string) => {
    setText(value)

    onChange(
      value
        .split('\n')
        .filter((line) => line.trim() !== '')
        .map((line) => line.trim())
    )
  }

  return (
    <Textarea
      minRows={DEFAULT_ROWS}
      maxRows={DEFAULT_ROWS}
      inputWrapperOrder={['label', 'input', 'description', 'error']}
      autosize
      {...props}
      value={text}
      onChange={(e) => handleChange(e.target.value)}
    />
  )
}
